<template>
  <div class="wizard kl-wizard">
    <div class="kl-wizard__main-col">
      <div class="kd-panel">
        <div class="kd-step-progress__panel-wrapper">
          <div class="kd-step-progress">
            <div class="kd-step-progress__arrow_holder">
              <a class="kd-ibtn" :class="{'is-disabled': firstStep}" @click="goPrevious()">
                <i class="kf kf-arrow-thin kf-flip-horizontal"></i>
              </a>
            </div>

            <div class="kd-step-progress__step-group">
              <div class="kd-step-progress__step-holder">
                <div
                  class="kd-step-progress__step"
                  :class="{'is-active': currentStep == (index + 1)}"
                  :style="{ width: stepWidth }"
                  v-for="(step, index) of steps"
                  @click="goToStep(index + 1)"
                >
                  <a href="javascript:" class="kd-step-progress__step_wrapper">
                    <div class="kd-step-progress__step_icon">
                      <span class="kf-stack kf-stack--circle">
                        <i class="kf kf-circle-outline"></i>
                        <i class="kf" :class="step['icon']"></i>
                      </span>
                    </div>

                    <div class="kd-step-progress__step_text">
                      <div class="kd-step-progress__step_text_line1">
                        {{step['title']}}
                      </div>

                      <div class="kd-step-progress__step_text_line2 txt-cap">
                        {{step['label']}}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div class="kd-step-progress__arrow_holder">
              <a
                class="kd-ibtn pull-right"
                :class="{'is-disabled': finalStep}"
                @click="goNext()"
              >
                <i class="kf kf-arrow-thin"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="kd-panel__content">
          <div class="row">
            <div class="col-xs-12">
              <div class="errors">
                <ul v-show="showErrors">
                  <li
                    class="wizard__error"
                    v-for="error of errors.all(slotName(currentStep))"
                  >
                    {{error}}
                  </li>
                </ul>
              </div>

              <div v-for="(step, index) of steps">
                <div :class="{'hidden': currentStep != (index + 1)}">
                  <slot :name="slotName(index + 1)"></slot>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="kd-panel__footer--full w-hr">
          <div class="dis-flx">
            <div class="flex-1 txt-left">
              <a
                class="inline-block-link inline-block-link--dark"
                :class="{'is-disabled': firstStep}"
                @click="goPrevious()"
              >
                <i class='kf kf-arrow-thin kf-flip-horizontal'></i>
                <span class="txt-cap ml03">{{I18n.t('dict.previous')}}</span>
              </a>
            </div>

            <div class="flex-1 txt-right">
              <a
                v-if="!finalStep"
                class="inline-block-link inline-block-link--dark"
                @click="goNext()"
              >
                <span class="txt-cap mr03">{{I18n.t('dict.next')}}</span>
                <i class='kf kf-arrow-thin arrow-right'></i>
              </a>

              <a
                v-if="cancelBtnVisible"
                class="inline-block-link txt-clr--danger"
                @click="onCancel()"
              >
                <span class="txt-upp">{{cancelBtnLabel}}</span>
              </a>

              <a
                v-if="finalStep"
                class="btn--sm btn--dark ml1 mb1"
                ref="complete"
                @click="onComplete()"
              >
                <span class="txt-upp">{{finalStepLabel}}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'wizard',

  inject: ['$validator'],

  props: {
    steps: {
      type: Array,
      default() {
        return [{label: 'set label', title: 'set title', icon: 'kf-info'}]
      }
    },
    finalStepLabel: {default: 'Save'},
    cancelBtnLabel: {default: 'Cancel'},
    showCancelBtn: {default: false},
    showErrorContainer: false,
  },

  data() {
    return {
      currentStep: 1,
    }
  },

  watch: {
    currentStep(val, oldVal) {
      if(val > oldVal) {
        this.errors.clear(this.slotName(this.currentStep+1))
      } else {
        this.errors.clear(this.slotName(this.currentStep-1))
      }
    },
  },

  computed: {
    firstStep() {
      return this.currentStep == 1
    },

    finalStep() {
      return this.currentStep == this.steps.length
    },

    stepWidth() {
      return 100/this.steps.length + '%'
    },

    cancelBtnVisible() {
      return this.currentStep == this.steps.length && this.showCancelBtn
    },

    showErrors() {
      if(this.showErrorContainer) {
        return this.errors.all(this.slotName(this.currentStep)).length > 0
      } else {
        return false
      }
    },
  },

  methods: {
    goNext() {
      this.validateStep(() => {
        if(this.currentStep < this.steps.length)
          this.currentStep++

        this.$emit('next', this.currentStep)
      })
    },

    goPrevious(index) {
      if (this.currentStep > 1)
        this.currentStep--

      this.$emit('previous', this.currentStep)
    },

    goToStep(i) {
      if(i < this.currentStep) {
        this.currentStep = i
        return true
      } else {
        this.handleGoTo(i)
      }
    },

    handleGoTo(i) {
      const previousStep = this.currentStep

      this.validateStep(() => {
        this.currentStep = i
        this.$emit('go_to', previousStep, i)
      })
    },

    onCancel() {
      this.$emit('cancel')
    },

    onComplete() {
      this.validateStep(() => this.$emit('complete'))
    },

    slotName(i) {
      return `step${i}`
    },

    validateStep(cb) {
      const scope = this.slotName(this.currentStep)

      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          return cb()
        } else {
          this.handleValidationError(e, scope)
          return false
        }
      }).catch((e) => {
        this.handleValidationError(e, scope)
      })
    },

    handleValidationError(e, scope) {
      if (this.errors.all(scope).length) {
        new Kadenze.Notice.error({
          title: 'Please fix the following validation errors',
          persistent: true,
          message: this.validationErrorMessage(scope),
        })
      } else {
        new Kadenze.Notice.error({
          message: 'Error validating step, please contact system administrators'
        })
      }
    },

    validationErrorMessage(scope) {
      return this.errors.flatMap(scope).flatMap(err => err).join(' ')
    }
  },
}
</script>
